import React from 'react';

import ForgotPasswordFormContainer from 'dpl/containers/ForgotPasswordFormContainer';

export default function UserAuthForgotPasswordForm() {
  return (
    <div className="UserAuthForgotPasswordForm">
      <ForgotPasswordFormContainer buttonClassName="w-100 w-60-lg button button--primary pv2 center" />
    </div>
  );
}
